
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: '戦略コンサルティング',
      description: '市場分析から競合調査まで、データに基づいた戦略立案で企業の方向性を明確化します。',
      features: ['市場分析', '競合調査', '事業戦略立案', 'ROI最適化']
    },
    {
      icon: 'ri-settings-3-line',
      title: '業務改善・効率化',
      description: '既存業務の見直しとプロセス改善により、生産性向上とコスト削減を実現します。',
      features: ['プロセス分析', '業務フロー改善', 'コスト削減', '品質向上']
    },
    {
      icon: 'ri-smartphone-line',
      title: 'デジタル変革支援',
      description: 'DXの推進により、デジタル技術を活用した新しいビジネスモデルの構築を支援します。',
      features: ['DX戦略', 'システム導入', 'データ活用', 'AI・IoT活用']
    },
    {
      icon: 'ri-team-line',
      title: '組織開発・人材育成',
      description: '組織力強化と人材育成により、持続可能な成長基盤の構築をサポートします。',
      features: ['組織診断', '人材育成', 'リーダーシップ開発', '企業文化改革']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            私たちのサービス
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            豊富な経験と専門知識を活かし、お客様のビジネス課題に最適なソリューションを提供します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
              </div>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <div className="grid grid-cols-2 gap-3">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
